<template>
	<div class="users-view">
		<div class="container-fluid p-0 " style="background-color: none !important; text-align: left;">
			<b-tabs card class="nonobg">
				<b-tab title="Uživatelé" class="nobg">
					<div class="row">						
						<div class="col col-md-4 input-group">
							<input type="text" class="form-control" v-model="vyhledavani" placeholder="Filtr" />
							<div class="input-group-append">
								<button class="btn btn-outline-primary" style="background-color: white;" type="button" id="button-addon2" @click="vyhledavani = ''"> X </button>
							</div>
						</div>
					</div>
					<UserCard class="mt-2" v-for="(user, usersIndex) of newUsers" 
						:key="usersIndex" 
						:user="user" 
						:powers="powers"
						:poskytovatele="usersPoskytovatele"
						@fetchUsers="fetchUsers"
						@newUserPowers="newUserPowers"
						@updateUsers="updateUsers"
					/>
				</b-tab>
				<b-tab title="Nový uživatel" class="nobg">
						<AddUser @newUserAdded="fetchUsers" /> 
				</b-tab>
			</b-tabs>
		</div>
	</div>
</template>

<script>
import AdditionsService from '@/services/AdditionsService'
import AddUser from '@/components/users/AddUser'
import UserCard from '@/components/users/UserCard'

export default {
	name: 'UsersView',
	
	components: {
		AddUser,
		UserCard,
	},

	data() {
		return {
			users: [],
			newUsers: [],
			
			powers: [],
			vyhledavani: '',
			usersPoskytovatele: [],
		}
	},

	mounted () {
		this.fetchUsers()
		this.fetchPowers()
		this.fetchUsersPoskytovatele()
	},

	methods: {
		newUserPowers (powers) {
			this.$emit('newUserPowers', powers)
		},

		async fetchPowers () {
			const powersData = await AdditionsService.fetchPowers()
			this.powers = powersData.data
		},

		async fetchUsers () {
			const usersData = await AdditionsService.fetchUsers()
			this.newUsers = usersData.data
			this.users = usersData.data
		},

		updateUsers (data) {
			for (const u of this.users) {
				if (u.name === data.name) {
					u.powers = data.powers
					this.$forceUpdate()
				}
			}
		},

		async fetchUsersPoskytovatele () {
			const usersPoskytovatele = await AdditionsService.fetchUsersPoskytovatele()
			this.usersPoskytovatele = usersPoskytovatele.data
		}
	},

	watch: {
		vyhledavani (to) {
			console.log('vyhledavani watch')
			if (to !== '') {
				const holdUsers = [...this.users]
				this.newUsers = holdUsers.filter(e => e.name.toLowerCase().includes(to.toLowerCase()))
			}

			if (to === '') {
				this.newUsers = this.users
			}
		}
	}
}
</script>

<style lang="stylus" scoped>
.users-view 
	display flex
	flex-direction column
	min-height 100vh
	max-height 100vh
	overflow-y scroll
	background-color #e0ecff

.vyhledavani-box
	margin-left 15px
	margin-top 10px
	text-align left
	font-size 28px
	line-height 40px
	font-weight bold
	display flex
	flex-direction row
	justify-content left

.vyhledavani
	height 40px
	width 300px
	margin-left 15px

.move-bit
	color gray

.vyhledavani-clear
	width 40px
	border none
	color gray
	margin-left 5px
	cursor pointer
</style>



// WEBPACK FOOTER //
// src/views/UsersView.vue